import { ChangeDetectionStrategy, Component } from '@angular/core';
// import { ConfigurableOperationDefinition } from '@phoenix/common';
import { DataService } from '../../../../../data/services/data.service';
import { GenericBaseModelDropDown } from '../../../../../shared/components/genericBaseModelDropDown';
// import { PromotionService } from '../../../services/promotion.service';

@Component({
  selector: 'app-promotion-action-dropdown',
  templateUrl: './promotion-action-dropdown.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true
})
export class PromotionActionDropdownComponent extends GenericBaseModelDropDown<any> {

  // allActions: ConfigurableOperationDefinition[] = [];
  allActions = [];

  constructor(
    // private service: PromotionService,
    private dataService: DataService) {
    super(null, null);
    // this.offlineMode = true;

  }
}